import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

/**
 * Msg 247 · light / dark mode across the member shell.
 *
 * Wave 8.1 (Feb 2026) · default flipped to CREAM for any device with no
 * saved choice. The `ww_light` / `allow_light` preview gate is retired;
 * the toggle and light mode are live in production. A saved choice always
 * wins (key `watuwako:theme`).
 */
const KEY = "watuwako:theme";
const ThemeCtx = createContext({ theme: "cream", toggle: () => {}, set: () => {}, forcedNight: false });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try {
      const saved = typeof window !== "undefined" && window.localStorage
        ? window.localStorage.getItem(KEY) : null;
      if (saved === "night" || saved === "cream") return saved;
    } catch {}
    return "cream";
  });

  useEffect(() => {
    try { document.documentElement.setAttribute("data-ww-theme", theme); } catch {}
    try { window.localStorage && window.localStorage.setItem(KEY, theme); } catch {}
  }, [theme]);

  const set = useCallback((t) => setTheme(t === "cream" ? "cream" : "night"), []);
  const toggle = useCallback(() => setTheme((t) => (t === "cream" ? "night" : "cream")), []);
  return <ThemeCtx.Provider value={{ theme, set, toggle, forcedNight: false }}>{children}</ThemeCtx.Provider>;
}
export const useTheme = () => useContext(ThemeCtx);
